
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";

import {CONST} from '../../environments/environment'


// 環境一覧取得APIの実行用
export async function executeGetUserList(){
	let session = await fetchAuthSession();
	let api_name = CONST.API_NAME;
	let path = CONST.API_PATH.USER;
	let my_init = {
		headers: {
			Authorization: session.tokens?.idToken?.toString()
		},
		queryParams: {
			accessToken: session.tokens?.accessToken?.toString()
		}
	};
	let response = await get({
		apiName: api_name,
		path,
		options: my_init
    }).response;
    response = await response.body.json();

	if ("errorMessage" in response) {
		throw response;
	}
	return response
}

// ### 